export { ALARM_DEFINITION_MODULE_NAME } from './alarm-definition.module'
